import { render, staticRenderFns } from "./OrderProblems.vue?vue&type=template&id=6089dd82&"
import script from "./OrderProblems.vue?vue&type=script&lang=js&"
export * from "./OrderProblems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports